import React, { FC, useContext } from 'react';
import styles from './LogIn.module.scss';
import { LogoDark } from 'esa-ui-library';
import { LogInForm } from './components';
import { useStore } from '../../../common';
import { AuthContext } from '../../../logic';

const LogIn: FC = (): JSX.Element => {
	const [, dispatch] = useStore(false);
	const { login } = useContext(AuthContext);

	const onLoginSubmit = () => {
		dispatch('LOGIN_SUBMIT', login);
	};

	return (
		<section className={styles.Login}>
			<section>
				<LogoDark />
				<div className={styles.LoginContent}>
					<h2>Welcome Back</h2>
					<p className={styles.Explanation}>Sign in to continue to use backoffice services.</p>
					<LogInForm onSubmit={onLoginSubmit} />
				</div>
			</section>
		</section>
	);
};

export { LogIn };
